/**
 * Mapping des codes d'icônes WeatherAPI vers OpenWeatherMap
 */
export const WEATHER_ICON_MAP = new Map([
  ['113', '01'], ['116', '02'], ['119', '03'], ['122', '04'], ['143', '50'],
  ['176', '10'], ['179', '13'], ['182', '13'], ['185', '13'], ['200', '11'],
  ['227', '13'], ['230', '13'], ['248', '50'], ['260', '50'], ['263', '09'],
  ['266', '09'], ['281', '13'], ['284', '13'], ['293', '10'], ['296', '10'],
  ['299', '10'], ['302', '10'], ['305', '10'], ['308', '10'], ['314', '13'],
  ['317', '13'], ['320', '13'], ['323', '13'], ['326', '13'], ['329', '13'],
  ['332', '13'], ['335', '13'], ['338', '13'], ['350', '13'], ['353', '09'],
  ['356', '10'], ['359', '10'], ['362', '13'], ['365', '13'], ['368', '13'],
  ['371', '13'], ['374', '13'], ['377', '13'], ['386', '11'], ['389', '11'],
  ['392', '11'], ['395', '11']
]);

/**
 * Traductions françaises des descriptions météo WeatherAPI (récupérées sur l'API)
 */
export const WEATHER_DESCRIPTIONS_FR = new Map([
  // Ensoleillé / Clair
  ['Sunny', 'Ensoleillé'], ['Clear', 'Clair'],
  // Nuageux
  ['Partly cloudy', 'Partiellement nuageux'], ['Partly Cloudy', 'Partiellement nuageux'],
  ['Cloudy', 'Nuageux'], ['Overcast', 'Couvert'],
  // Brouillard
  ['Mist', 'Brume'], ['Fog', 'Brouillard'], ['Freezing fog', 'Brouillard givrant'],
  // Pluie
  ['Patchy rain possible', 'Pluie possible par endroits'], ['Patchy rain nearby', 'Pluie à proximité'],
  ['Light rain', 'Pluie légère'], ['Moderate rain', 'Pluie modérée'], ['Heavy rain', 'Pluie forte'],
  ['Light rain shower', 'Averse légère'], ['Moderate or heavy rain shower', 'Averse modérée à forte'],
  ['Torrential rain shower', 'Averse torrentielle'],
  ['Patchy light rain', 'Pluie légère par endroits'], ['Moderate rain at times', 'Pluie modérée par moments'],
  ['Heavy rain at times', 'Pluie forte par moments'],
  // Bruine
  ['Patchy light drizzle', 'Bruine légère par endroits'], ['Light drizzle', 'Bruine légère'],
  // Neige
  ['Patchy snow possible', 'Neige possible par endroits'], ['Patchy snow nearby', 'Neige à proximité'],
  ['Light snow', 'Neige légère'], ['Moderate snow', 'Neige modérée'], ['Heavy snow', 'Neige forte'],
  ['Patchy light snow', 'Neige légère par endroits'], ['Patchy moderate snow', 'Neige modérée par endroits'],
  ['Patchy heavy snow', 'Neige forte par endroits'],
  ['Light snow showers', 'Averses de neige légères'], ['Moderate or heavy snow showers', 'Averses de neige modérées à fortes'],
  ['Blowing snow', 'Neige soufflée'], ['Blizzard', 'Blizzard'],
  // Grésil / Verglas
  ['Patchy sleet possible', 'Grésil possible par endroits'], ['Light sleet', 'Grésil léger'],
  ['Moderate or heavy sleet', 'Grésil modéré à fort'], ['Light sleet showers', 'Averses de grésil légères'],
  ['Moderate or heavy sleet showers', 'Averses de grésil modérées à fortes'],
  ['Patchy freezing drizzle possible', 'Bruine verglaçante possible par endroits'],
  ['Freezing drizzle', 'Bruine verglaçante'], ['Heavy freezing drizzle', 'Bruine verglaçante forte'],
  ['Light freezing rain', 'Pluie verglaçante légère'], ['Moderate or heavy freezing rain', 'Pluie verglaçante modérée à forte'],
  // Grêle
  ['Ice pellets', 'Granules de glace'], ['Light showers of ice pellets', 'Averses légères de granules de glace'],
  ['Moderate or heavy showers of ice pellets', 'Averses modérées à fortes de granules de glace'],
  // Orages
  ['Thundery outbreaks possible', 'Orages possibles'], ['Patchy light rain with thunder', 'Pluie légère avec tonnerre par endroits'],
  ['Moderate or heavy rain with thunder', 'Pluie modérée à forte avec tonnerre'],
  ['Patchy light snow with thunder', 'Neige légère avec tonnerre par endroits'],
  ['Moderate or heavy snow with thunder', 'Neige modérée à forte avec tonnerre']
]);


/**
 * Extrait le code d'icône WeatherAPI et le convertit au format OpenWeatherMap
 */
export function extractWeatherAPIIcon(iconUrl: string): string {
  const match = iconUrl.match(/\/(\d+)\.png/);
  const code = match?.[1] || '113';
  const baseIcon = WEATHER_ICON_MAP.get(code) || '01';
  const dayNight = iconUrl.includes('/night/') ? 'n' : 'd';

  return `${baseIcon}${dayNight}`;
}

/**
 * Traduit une description météo anglaise en français
 */
export function translateWeatherDescription(englishDescription: string): string {
  return WEATHER_DESCRIPTIONS_FR.get(englishDescription) || englishDescription;
}